module.exports = {
          srcSet: __webpack_public_path__ + "703925e3bec732175896672a724dc8c1-1249.png"+" 1249w",
          images:[ {path: __webpack_public_path__ + "703925e3bec732175896672a724dc8c1-1249.png",width: 1249,height: 563}],
          src: __webpack_public_path__ + "703925e3bec732175896672a724dc8c1-1249.png",
          toString:function(){return __webpack_public_path__ + "703925e3bec732175896672a724dc8c1-1249.png"},
          
          width: 1249,
          height: 563
        }